<template>
  <Card tag="form" class="page-mutate-basis" @submit.prevent="$emit('submit')">
    <template #default>
      <div class="page-mutate-basis__input">
        <InputComponent
          v-model="value.name"
          data-field="name"
          :label="labels.name"
          required
          :is-valid="validator.fields.name.valid"
          :validation-message="validator.fields.name.error"
          autocomplete="off"
        />
        <Address
          v-if="isActive && language"
          v-model="value.address"
          :label="labels.address"
          :disabled="Boolean(getDisabledField('address'))"
          v-tooltip.bottom="getDisabledField('address')"
          data-field="address"
          :language="language"
        />
      </div>
      <CustomFields
        v-model="value.customFields"
        :schema="customFieldSchemas"
        :data="data"
        :placement="['basis', 'page:basis']"
        :validator="validator"
        validator-prefix="customFields"
        :disabledFields="$path('metadata.disabledFields.page', item)"
      />
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import { Capitalize } from '@/utils'
import Address from '@/components/Address'
import CustomFields from '@kvass/custom-fields'
import { i18n } from '@/i18n'
import { mapState, mapGetters } from 'vuex'

const meta = {
  order: 1,
  id: 'basis',
  label: i18n.tc('basis'),
  icon: ['fal', 'file-alt'],
  fields: ['name', 'address'],
}

export { meta }
export default {
  props: {
    value: Object,
    data: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    isActive: Boolean,
  },
  computed: {
    ...mapGetters('Page', ['getDisabledField']),
    ...mapState('Page', {
      item(state) {
        return state.item && Object.keys(state.item).length ? state.item : this.data
      },
    }),
    language() {
      return this.$path('item.metadata.language')
    },
  },
  methods: {
    Capitalize,
  },
  components: {
    Card,
    InputComponent,
    Address,
    CustomFields,
  },
}
</script>

<style lang="scss">
.page-mutate-basis {
  max-width: 900px;

  &__input {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: $form-gap;
  }

  .custom-fields {
    margin-top: 1rem;
  }
}
</style>
